import { render } from "./Tile.vue?vue&type=template&id=351ae4d1&scoped=true"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"

import "./Tile.vue?vue&type=style&index=0&id=351ae4d1&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-351ae4d1"

export default script